module.exports = __webpack_public_path__ + "static/section4-a9a1c41c73420e42b5079492698a4cd8.svg";